import { ColorEnum } from '@/constants/color'
import { Layout } from '@/features/layout/types'
import PaymentTotalRow from '@/features/shiftCloseouts/components/ShiftCloseoutForm/parts/PaymentTotals/parts/PaymentTotalRow'
import {
    ShiftCloseoutPaymentMethod,
    ShiftCloseoutReconciliation,
} from '@/features/shiftCloseouts/types'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface PaymentTotalsProps {
    layout: Layout
    paymentMethods: ShiftCloseoutPaymentMethod[]
    reconciliation: ShiftCloseoutReconciliation
}

const PaymentTotals: FC<PaymentTotalsProps> = ({ layout, paymentMethods, reconciliation }) => {
    const { t } = useTranslation()

    return (
        <View style={styles.container}>
            <Typography.Heading variant="h5" style={styles.heading}>
                {t('shiftCloseouts.paymentMethods.heading')}
            </Typography.Heading>

            {paymentMethods.length === 0 ? (
                <View style={styles.emptyState}>
                    <Typography.Description style={styles.emptyStateText}>
                        {t('shiftCloseouts.paymentMethods.empty')}
                    </Typography.Description>
                </View>
            ) : (
                <View style={styles.list}>
                    {paymentMethods.map((paymentMethod) => (
                        <PaymentTotalRow
                            key={paymentMethod.identifier}
                            difference={reconciliation.differences[paymentMethod.identifier]}
                            layout={layout}
                            paymentMethod={paymentMethod}
                        />
                    ))}
                </View>
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        gap: 8,
    },
    heading: {
        color: ColorEnum.GRAY_900,
    },
    list: {
        gap: 8,
    },
    emptyState: {
        alignItems: 'center',
        padding: 24,
        borderColor: ColorEnum.GRAY_200,
        borderRadius: 12,
        borderWidth: 1,
    },
    emptyStateText: {
        color: ColorEnum.GRAY_600,
        textAlign: 'center',
    },
})

export default PaymentTotals
